import {AbstractControl, FormGroup, ValidationErrors} from '@angular/forms';

export class CoreFormValidationHelper {
    static validate(control: AbstractControl, options: { onlySelf: boolean } = {onlySelf: true}): void {
        control.markAsTouched(options);
        control.updateValueAndValidity(options);

        if (control instanceof FormGroup) {
            Object.keys(control.controls).forEach((field: string) => this.validate(control.get(field) as AbstractControl));
        }
    }

    static getValidationErrors(control: AbstractControl): ValidationErrors {
        let validationErrors: ValidationErrors = control.errors ?? {};

        if (control instanceof FormGroup) {
            Object.keys(control.controls).filter((field: string): boolean => 0 !== (control.get(field)?.errors ?? []).length).forEach((field: string): void => {
                validationErrors[field] = this.getValidationErrors(control.get(field) as AbstractControl);
            });
        }

        return validationErrors;
    }
}
